import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { CLIENT_TYPES, WHICHENSURE_TYPES } from "../../../constants/personaldata";
import { formControls } from "../constants/forms";

const useWhichEnsureSection = () => {
    const { watch, setValue } = useFormContext();
    const clientType = watch(formControls.clientType.key);
    const isOwner = clientType === CLIENT_TYPES.OWNER;
    const isTenant = clientType === CLIENT_TYPES.ROOMER;

    useEffect(() => {
        if (isTenant) {
            setValue(formControls.whichEnsure.key, WHICHENSURE_TYPES.ASSETS, true);
        }
        console.log("se activaaa a cada rato")
    }, [isTenant, setValue]);

    return { isOwner, isTenant, clientType };
};

export default useWhichEnsureSection;
